import { __, invertObj, prop } from 'ramda';

import { MEDIA_TYPE } from '../../../types/press-media';

export const PRISMIC_TO_TYPE_MEDIA = {
  Infographie: MEDIA_TYPE.INFOGRAPHIC,
  'Dossier de presse': MEDIA_TYPE.COMMUNICATION,
  'Communiqué de presse': MEDIA_TYPE.RELEASE,
  Photo: MEDIA_TYPE.PHOTO,
  Vidéo: MEDIA_TYPE.VIDEO,
  Audio: MEDIA_TYPE.AUDIO,
  Publication: MEDIA_TYPE.PUBLICATION,
};

export const toMediaType = prop(__, PRISMIC_TO_TYPE_MEDIA);
export const toMediaPrismic = prop(__, invertObj(PRISMIC_TO_TYPE_MEDIA));
